<template>
<div class="chapter">
<div class="inner_page">
<p class="P-P30"></p>
<p class="P-P25"> </p>
<p class="P-P25"> </p>
<p class="P-P12"><span class="S-huge"><span class="S-T">Life is not a series of gig lamps symmetrically arranged; life is a luminous halo, a semi-transparent envelope surrounding us from the beginning of consciousness to the end.</span></span><span class="S-T"><br class="calibre3"/></span>  </p>
<p class="P-P31"><span class="S-huge"><span class="S-T">Virginia Woolf</span></span> </p>
<p class="P-P31"> </p>
<p class="P-P31"> </p>
<p class="P-P31"> </p>
<p class="P-P32">I have been astonished that men could die martyrs for their religion – I have shudder’d at it. I shudder no more. I could be martyr’d for my religion. Love is my religion and I could die for that.  I could die for you.</p>
<p class="P-P33"><br class="calibre3"/>
  John Keats</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?6bcb5710